import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';

export const ArbitrationAgreementConfirmationModal = ({
  placementId,
  open,
  onClose,
}: {
  placementId: string;
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(placementDetailsAction.createExternalTaskforArbitrationAgreement({ placementId: placementId }));
    onClose();
  };
  return (
    <GenericDialog
      open={open}
      dialogTitleProps={{
        text: t('placement.arbitrationAgreementBtn.confirmationModal.title'),
      }}
      fullWidth
      maxWidth={'sm'}
      disableEscapeKeyDown
      dialogActions={[
        {
          onClick: onClose,
          text: t('placement.arbitrationAgreementBtn.confirmationModal.cancel'),
          color: 'info',
        },
        {
          onClick: onConfirm,
          text: t('placement.arbitrationAgreementBtn.confirmationModal.confirm'),
          variant: 'contained',
        },
      ]}
    >
      <Typography>{t('placement.arbitrationAgreementBtn.confirmationModal.body')}</Typography>
    </GenericDialog>
  );
};
